import React from "react";
import { Button } from "./ui/button";
import { Play, ArrowRight, Package, BarChart3, ShoppingCart } from "lucide-react";

const Hero = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-grid-slate-200 bg-[size:20px_20px] opacity-20"></div>
      </div>
      
      {/* Floating Elements */}
      <div className="absolute top-20 right-20 opacity-20">
        <Package size={40} className="text-blue-600 animate-bounce" />
      </div>
      <div className="absolute bottom-32 left-10 opacity-20">
        <BarChart3 size={35} className="text-blue-500 animate-pulse" />
      </div>
      <div className="absolute top-1/3 left-16 opacity-15">
        <ShoppingCart size={45} className="text-blue-700" />
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6 animate-fade-in">
              🚀 Software de Inventarios Líder en el Mercado
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                SAIP
              </span>
              <br />
              <span className="text-gray-800">
                Control Total de tu Inventario
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Revoluciona la gestión de tu negocio con SAIP, el sistema más avanzado para 
              control de inventarios, punto de venta y análisis empresarial. Diseñado para 
              empresas que buscan excelencia operacional.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <Button 
                size="lg" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
              >
                Solicitar Demo Gratuita
                <ArrowRight className="ml-2" size={20} />
              </Button>
              
              <Button 
                variant="outline" 
                size="lg" 
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-4 text-lg font-semibold"
              >
                <Play className="mr-2" size={20} />
                Ver Video Demo
              </Button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-8 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                Más de 1000+ empresas confían en SAIP
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                Implementación en 24 horas
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                Soporte 24/7
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-2xl p-6 transform hover:scale-105 transition-transform duration-300">
              <div className="absolute -top-4 -right-4 bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-bold animate-bounce">
                ¡En Vivo!
              </div>
              
              {/* Mock Dashboard Preview */}
              <div className="bg-gradient-to-r from-blue-500 to-blue-700 rounded-lg p-4 mb-4">
                <div className="text-white text-lg font-bold mb-2">Dashboard SAIP</div>
                <div className="grid grid-cols-3 gap-2">
                  <div className="bg-white/20 rounded p-2 text-center">
                    <div className="text-white text-sm">Ventas</div>
                    <div className="text-white text-lg font-bold">$45,280</div>
                  </div>
                  <div className="bg-white/20 rounded p-2 text-center">
                    <div className="text-white text-sm">Productos</div>
                    <div className="text-white text-lg font-bold">1,547</div>
                  </div>
                  <div className="bg-white/20 rounded p-2 text-center">
                    <div className="text-white text-sm">Stock Bajo</div>
                    <div className="text-white text-lg font-bold">23</div>
                  </div>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex justify-between items-center p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-600">Producto A</span>
                  <span className="text-sm font-medium text-green-600">En Stock</span>
                </div>
                <div className="flex justify-between items-center p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-600">Producto B</span>
                  <span className="text-sm font-medium text-yellow-600">Stock Medio</span>
                </div>
                <div className="flex justify-between items-center p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-600">Producto C</span>
                  <span className="text-sm font-medium text-red-600">Stock Bajo</span>
                </div>
              </div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-4 animate-float">
              <div className="text-2xl font-bold text-blue-600">99.9%</div>
              <div className="text-sm text-gray-600">Uptime</div>
            </div>
            
            <div className="absolute -top-6 -left-6 bg-white rounded-xl shadow-lg p-4 animate-float" style={{animationDelay: '1s'}}>
              <div className="text-2xl font-bold text-green-600">+47%</div>
              <div className="text-sm text-gray-600">Eficiencia</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;